export const requirementsConstants = {
    errors: {
        fetchFailed: "Failed to load requirements.",
        createFailed: "Failed to add requirement.",
        updateFailed: "Failed to update requirement.",
        toggleFailed: "Failed to toggle requirement.",
        deleteFailed: "Failed to delete requirement.",
        genericError: "Something went wrong.",
    },
    messages: {
        createSuccess: "Requirement added.",
        updateSuccess: "Requirement updated.",
        toggleSuccess: "Requirement toggled.",
        deleteSuccess: "Requirement deleted.",
    },
};
